export default __webpack_public_path__ + "/dist/images/image00022.6c9210b29f680b2e3f674aaa3989dcd2.jpg";